import { defineStore } from "pinia";

export const useGlobalStore = defineStore("globalState", {
    state: () => ({
        banks: [],
        nodeAccounts: [],
        suppliers: [],
        purchasers: [],
        regions: [],
        provinces: [],
        cities: [],
        barangays: [],
        agents: [],
        taxes: [],
        paymentTerm: [],
        branches: [],
        department: [],
        entities: [],
        glAccounts: [],
        slAccounts: [],
        mappings: [],
        modes: [],
        request_header: '',
        dashboard_data: [],
        dashboard_payable: [],
        dashboard_receivable: [],
        dashboard_sales: [],
        users: [],
        item_types: [],
        categories: [],
        mode_of_payment: [],
        transaction_purpose: [],
        item_units: [],
        sys_configs: [],
        reasons: [],
        assigned_branch: [],
        default_branch: '',
        all_branches: '',
        modules: []
    }),

    getters: {
        getBanks: (state) => state.banks,
        getRegions: (state) => state.regions,
        getProvinces: (state) => state.provinces,
        getCities: (state) => state.cities,
        getBarangays: (state) => state.barangays,
        getAgent: (state) => state.agents,
        getTaxes: (state) => state.taxes,
        getNodeAccounts: (state) => state.nodeAccounts,
        getPaymentTerms: (state) => state.paymentTerms,
        getBranches: (state) => state.branches,
        getGLAccounts : (state) => state.glAccounts,
        getSLAccounts : (state) => state.slAccounts,
        getEntities : (state) => state.entities,
        getMappings : (state) => state.mappings,
        getDashboardData : (state) => state.dashboard_data,
        getDashboardReceivable : (state) => state.dashboard_receivable,
        getDashboardSales : (state) => state.dashboard_sales,
        getUsers : (state) => state.users,
        getCategories: (state) => state.categories,
        getItemUnits: (state) => state.item_units
    }
})
